import { InjectionToken } from '@angular/core';

export type Environment = {
  production: boolean;
  region: string;
  identityPoolId: string;
  userPoolId: string;
  userPoolWebClientId: string;
  oktaIdentityPoolId: string;
  oktaUserPoolId: string;
  oktaUserPoolDomain: string;
  oktaUserPoolWebClientId: string;
  envName: string;
  apiUrl: string;
  wssUrl: string;
};

export const ENVIRONMENT = new InjectionToken<Environment>('Environment');
